import { type ReactNode } from 'react'
import * as S from '@/components/pdfRender/PdfRender.styled'
import { PdfProofWrapperFooter } from '@/components/pdfRender/PdfProofWrapperFooter'
import { PdfProofWrapperHeader } from '@/components/pdfRender/PdfProofWrapperHeader'

export const PageProofWrapper = ({
  children,
  pageIndex,
  contentDimensions,
  showVerticalCenter,
  showHorizontalCenter,
  foldMarks = [],
  productBleedClipped,
}: {
  children: ReactNode
  pageIndex: number
  contentDimensions: { width: number; height: number }
  showVerticalCenter: boolean
  showHorizontalCenter: boolean
  /** A trifold page's fold positions, in px from the page's left edge. */
  foldMarks?: number[]
  productBleedClipped: boolean
}) => {
  return (
    <S.PageProofContainer key={pageIndex}>
      <PdfProofWrapperHeader contentDimensions={contentDimensions} />

      <S.PageProofContentArea>
        <S.PageProofWrapper
          $contentWidth={contentDimensions.width}
          $contentHeight={contentDimensions.height}
        >
          <S.PageProofContent
            $contentWidth={contentDimensions.width}
            $contentHeight={contentDimensions.height}
          >
            {children}
          </S.PageProofContent>
          <S.TrimMarks
            $corner="top-left"
            $contentWidth={contentDimensions.width}
            $contentHeight={contentDimensions.height}
            $productBleedClipped={productBleedClipped}
          />
          <S.TrimMarks
            $corner="top-right"
            $contentWidth={contentDimensions.width}
            $contentHeight={contentDimensions.height}
            $productBleedClipped={productBleedClipped}
          />
          <S.TrimMarks
            $corner="bottom-left"
            $contentWidth={contentDimensions.width}
            $contentHeight={contentDimensions.height}
            $productBleedClipped={productBleedClipped}
          />
          <S.TrimMarks
            $corner="bottom-right"
            $contentWidth={contentDimensions.width}
            $contentHeight={contentDimensions.height}
            $productBleedClipped={productBleedClipped}
          />
          <S.TrimMarks
            $corner="center"
            $showVerticalCenter={showVerticalCenter}
            $contentWidth={contentDimensions.width}
            $contentHeight={contentDimensions.height}
            $productBleedClipped={productBleedClipped}
          />
          <S.TrimMarks
            $corner="sides"
            $showHorizontalCenter={showHorizontalCenter}
            $contentWidth={contentDimensions.width}
            $contentHeight={contentDimensions.height}
            $productBleedClipped={productBleedClipped}
          />
          {foldMarks.map((fold) => (
            <S.FoldMarks
              key={fold}
              data-testid="proof-fold-mark"
              $fold={fold}
              $contentHeight={contentDimensions.height}
              $productBleedClipped={productBleedClipped}
            />
          ))}
        </S.PageProofWrapper>
      </S.PageProofContentArea>

      <PdfProofWrapperFooter contentDimensions={contentDimensions} />
    </S.PageProofContainer>
  )
}
